module.exports = __webpack_public_path__ + "img/red-trash.a88141fb.svg";